import { supabase } from "@/lib/supabase";
import { api } from "@/lib/api";

// Single source of truth for "human service" contact details shown across the
// driver app (persistent Speak-to-a-human button, Emergency page, etc.).
// Customer hotlines come from the customer record (RLS-readable by the driver);
// the AA fleet number + VAPID key come from service-role app_config via the API.
// Cached in sessionStorage so the persistent button renders instantly.

const CACHE_KEY = "relay_driver_contact";
const TTL_MS = 5 * 60 * 1000;

export function tel(n) {
  return (n || "").replace(/[^\d+]/g, "");
}

export async function getDriverContact(force = false) {
  if (!force) {
    try {
      const raw = sessionStorage.getItem(CACHE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && Date.now() - parsed.at < TTL_MS) return parsed.data;
      }
    } catch (_) { /* ignore */ }
  }

  const { data: drivers } = await supabase
    .from("drivers")
    .select("customers(name, support_phone, emergency_phone)")
    .limit(1);
  const customer = drivers?.[0]?.customers || null;

  let config = { aa_fleet_phone: null, aa_fleet_label: "AA Fleet Assistance", vapid_public_key: null };
  try { config = await api.driverConfig(); } catch (_) { /* config is optional */ }

  const data = {
    customer_name: customer?.name || null,
    support_phone: customer?.support_phone || null,
    emergency_phone: customer?.emergency_phone || null,
    aa_fleet_phone: config?.aa_fleet_phone || null,
    aa_fleet_label: config?.aa_fleet_label || "AA Fleet Assistance",
    vapid_public_key: config?.vapid_public_key || null,
  };
  try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), data })); } catch (_) { /* ignore */ }
  return data;
}

export function clearDriverContactCache() {
  try { sessionStorage.removeItem(CACHE_KEY); } catch (_) { /* ignore */ }
}
